
<template>
   <section class="wrapper admin-dashboard">
    <div class="tab">
      <h2 class="tab-heading">Vehicles</h2>
      <div class="tabbed-content">
        <dl>
          <router-link :to="{name: 'VehiclesSummary', params: {initialFilter: 'Call Back'}}"><dt class="data-label">Call Back</dt></router-link>
          <dd class="data-content">{{ vehicleData.call_back }} </dd>
          <router-link :to="{name: 'VehiclesSummary', params: {initialFilter: 'New Vehicle'}}"><dt class="data-label">New Vehicles</dt></router-link>
          <dd class="data-content">{{ vehicleData.new_vehicles }} </dd>
          <router-link :to="{name: 'VehiclesSummary', params: {initialFilter: 'Pending Donor Info'}}"><dt class="data-label">Pending Donor Info</dt></router-link>
          <dd class="data-content">{{ vehicleData.pending_donor_info }} </dd>
          <router-link :to="{name: 'VehiclesSummary', params: {initialFilter: 'Sold - Pending Payment'}}"><dt class="data-label">Sold - Pending Payment</dt></router-link>
          <dd class="data-content">{{ vehicleData.sold_pending_payment }}</dd>
        </dl>
        <router-link :to="{name: 'VehicleAdd'}" class="secondary-action">+ Add New Vehicle</router-link>
      </div>
    </div>
    <div class="tab">
      <h2 class="tab-heading">Payables</h2>
      <div class="tabbed-content">
        <dl>
          <router-link :to="{name: 'Payables'}"><dt class="data-label">Charity Payables</dt></router-link>
          <dd class="data-content">{{ payableData.charity_payables }} Vehicles</dd>
          <router-link :to="{name: 'Payables', params: {showCharityPayables: false}}"><dt class="data-label">Towing Payables</dt></router-link>
          <dd class="data-content">{{ payableData.towing_payables }} Vehicles</dd>
        </dl>
      </div>
    </div>
  </section>
</template>

<script>
// import auth from '@/auth'
import store from '@/store'

export default {
  name: 'Dashboard',
  beforeRouteEnter (to, from, next) {
    let vehicleData = null
    let payableData = null
    Promise.all([
      store.functions.vehicles.getDashboardData((response) => { vehicleData = response.data }),
      store.functions.payables.getDashboardData((response) => { payableData = response.data }),
    ]).then(() => {
      next(vm => vm.setData(vehicleData, payableData))
    })
  },
  data () {
    return {
      vehicleData: {},
      payableData: {}
    }
  },
  methods: {
    setData (vehicle, payable) {
      this.vehicleData = vehicle
      this.payableData = payable
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue